module.exports = __webpack_public_path__ + "static/media/growth.4d3c5310.jpg";